/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class Data extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  async beforeModel() {
    if (!this.appService.app.hasStandalonePlatform('salesforce')) {
      this.router.transitionTo('apps.app.standalone.deploy.intercom-messenger');
    }
  }
}
